import { Injectable } from '@angular/core';

/**
 * This service provides a centralized way to handle errors across both shared libraries
 * and the main application. It can be used by components, utilities, or global handlers
 * to log errors, send them to a monitoring service, or perform other error-related actions.
 * The logic here can be customized once and reused consistently across all error handling scenarios.
 */

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  handleError(error: Error, label?: string): void {
    console.error(`[ErrorHandlerService] ${label || 'Error'}:`, error);

    // For example: send errors to a monitoring backend
    // this.monitoringService.capture(error, { label });
  }
}
